<template>
  <div>
    <Header />
    <b-container id="body-container" fluid>
      <b-row class="justify-content-center">
        <b-col cols="10">


           <b-row align-h="start" align-v="center" class="header-text-container">
            <b-col cols="8" md="4">
              <span>
                <h4 class="text-blackish title-body">Report Abuse</h4>
              </span>
            </b-col>
            <b-col cols="4" md="3">
              <div class="color-design"></div>
            </b-col>
          </b-row>

          <b-row align-h="start" class="header-text-container">

            <b-col md="12">
                <div>
                  </div>
                  <div>
                      <div>
                            <p>Our goal is to help our customers send email their recipients want, period. There’s no room for spam at Gravity. That’s why our customers agree to a <a href="https://www.launchgravity.com/policies/terms-of-use">strict anti-abuse messaging policy</a>. Still, some bad actors won’t follow the rules, and even well-intentioned senders might make a mistake. We work hard to keep spam out of our system, and we take this job very seriously.</p>

                            <p>Help us help you — please submit your report to us directly at <a href='mailto:abuse@launchgravity.com'>abuse@launchgravity.com</a> and please be sure to include the full email headers in your report. (By the way, if you need help finding the detailed message headers, Gmail has published a helpful <a href="https://support.google.com/mail/answer/29436?hl=en&visit_id=637024566132962359-2868898710&rd=1">guide to finding email headers</a> in a variety of email clients.)</p>

                            <p>V2.9 April 1, 2020</p>
                      </div>
                  </div>

            </b-col>
          </b-row>

        </b-col>
      </b-row>

    </b-container>
    <Footer />
  </div>
</template>


<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/screens/home/header.sass
</style>


<script>
// sub components
import Header from './header.vue'
import Footer from '@/components/footer.vue'
//import startFreeTrial from '@/components/startFreeTrial'

export default {
  name: 'home',
  components: {
    Header,
    Footer,
  },
}
</script>
